import { LocationContext } from "@provider/LocationProvider";
import { useContext } from "react";

const useLocationRange = () =>{

    return useContext(LocationContext);
}

export default useLocationRange;